import api from "@/services/api";

const _http = {
  getAsset(params) {
    return api.get("/asset", { params });
  },

  getAssetById(id) {
    return api.get(`/asset/${id}`);
  },

  getAssetNumbers(id) {
    return api.get(`/asset/${id}/numbers`);
  },

  createAsset(data) {
    const isFormData = data instanceof FormData;
    return api.post("/asset", data, {
      headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
      timeout: isFormData ? 60000 : 10000,
    });
  },

  updateAsset(id, data) {
    const isFormData = data instanceof FormData;
    return api.put(`/asset/${id}`, data, {
      headers: isFormData ? { "Content-Type": "multipart/form-data" } : {},
      timeout: isFormData ? 60000 : 10000,
    });
  },

  getSignedUrl(key) {
    return api.get("/s3-signed-url", { params: { key } });
  },
};



export default {
  async getAll(query = {}) {
    try {
      const res = await _http.getAsset(query);
      return {
        data: res.data.data.map((asset) => asset),
        total: res.data.total || 0,
      };
    } catch (error) {
      console.error(error);
      return {
        data: [],
        total: 0,
      };
    }
  },

  async getById(id) {
    try {
      const res = await _http.getAssetById(id);
      return res.data.data;
    } catch (error) {
      console.error(error);
      return null;
    }
  },

  async getAssetNumbers(id) {
    try {
      const res = await _http.getAssetNumbers(id);
      return res.data.data || [];
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  async create(payload) {
    try {
      const response = await _http.createAsset(payload);
      return response;
    } catch (error) {
      console.error("Error creating document:", error);
      throw error;
    }
  },

  async update(id, payload) {
    try {
      const response = await _http.updateAsset(id, payload);
      return response;
    } catch (error) {
      console.error("Error updating document:", error);
      throw error;
    }
  },

  async getSignedUrl(key) {
    try {
      const res = await _http.getSignedUrl(key);
      return res.data; // { success, url }
    } catch (error) {
      console.error("Error getting signed url:", error);
      return null;
    }
  },
};

